import * as Yup from 'yup';

export const ProjectCustomerFormSchema = () =>
  Yup.object({
    id: Yup.string().default(''),
  });

export const ProjectGuestFormSchema = () =>
  Yup.object({
    id: Yup.string().default(''),
  });

export const ProjectItineraryFormSchema = () =>
  Yup.object({
    id: Yup.string(),
    date: Yup.date().nullable().default(null),
    route: Yup.string().nullable().default(''),
    description: Yup.string().default(''),
    isComplete: Yup.boolean().default(false),
    customId: Yup.string().default(''),
  });

export const ProjectSalesFormSchema = () =>
  Yup.object({
    id: Yup.string().default(''),
  });

export const ProjectFormSchema = () =>
  Yup.object({
    name: Yup.string().default(''),
    description: Yup.string().default(''),
    projectCustomers: Yup.array(ProjectCustomerFormSchema()).default([]),
    projectGuests: Yup.array(ProjectGuestFormSchema()).default([]),
    projectItineraries: Yup.array(ProjectItineraryFormSchema()).default([]),
    sales: Yup.array(ProjectSalesFormSchema()).default([]),
    code: Yup.string().default(''),
  });

export type ProjectFormType = Yup.InferType<
  ReturnType<typeof ProjectFormSchema>
>;

export type ProjectSalesFormType = Yup.InferType<
  ReturnType<typeof ProjectSalesFormSchema>
>;

export type ProjectItineraryFormType = Yup.InferType<
  ReturnType<typeof ProjectItineraryFormSchema>
>;

export type ProjectGuestFormType = Yup.InferType<
  ReturnType<typeof ProjectGuestFormSchema>
>;

export type ProjectCustomerFormType = Yup.InferType<
  ReturnType<typeof ProjectCustomerFormSchema>
>;
